<template>
    <div class="container">
        <div class="content">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small" label-width="64px">
                <el-form-item label="在职状态">
                    <el-select v-model="searchForm.status" placeholder="请选择在职状态" clearable>
                        <el-option v-for="item in statuss" :key="item.dictId" :label="item.dictName" :value="item.dictId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="员工姓名">
                    <el-autocomplete class="inline-input" v-model="searchForm.reallyName" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"
                        clearable></el-autocomplete>
                </el-form-item>
                <el-form-item label="入职日期">
                    <eldate @changeData="changeData($event, 'employeeTime')" :dateData="employeeTime"></eldate>
                </el-form-item>

                <el-form-item label="所属部门">
                    <el-cascader @change="handleSelectOrgId" v-model="searchForm.orgId1" :options="options" :show-all-levels="false" :props="{
                        checkStrictly: true,
                        label: 'orgName',
                        value: 'orgPath',
                        children: 'children',
                    }" clearable filterable></el-cascader>
                </el-form-item>
                <el-form-item label="直接上级">
                    <el-autocomplete class="inline-input" v-model="searchForm.directSuperior" :fetch-suggestions="querySearch1" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect1"
                        clearable></el-autocomplete>
                </el-form-item>
                <el-form-item label="职位">
                    <template #label>职<span class="space"></span>位</template>
                    <el-select v-model="searchForm.positionId" placeholder="请选择职位" clearable filterable>
                        <el-option v-for="items in positionList" :key="items.positionCode" :label="items.name" :value="items.positionCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="登录手机号">
                    <template #label>
                        <div class="custom-label">登录<br/>手机号</div>
                    </template>
                    <el-input v-model="searchForm.phoneNumber" placeholder="请输入登录手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="创建日期">
                    <eldate @changeData="changeData($event, 'createTime')" :dateData="createTime"></eldate>
                </el-form-item>


                <el-form-item style="float: right;margin-right: 0px;">
                    <div style="display: flex;">
                        <div class="s-btn" @click="fetchData('search')">查询</div>
                        <div class="r-btn" @click="fetchData('reset')">重置</div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="line"></div>
            <div class="data-title">
                <div style="display: flex;height: 32px;">
                    <div class="title-line"></div>
                    <div class="title-name">数据列表</div>
                </div>

                <div class="title-btn">
                    <div class="title-btn-item" style="margin-right: 12px;" @click="deliverData()" v-if="parArray.indexOf('employee_export') != -1">
                        <img src="../../../assets/icon_daochu.png" style="width: 16px;height: 16px;" />
                        <div class="btn-l">导出列表</div>
                    </div>
                    <div class="title-btn-item" @click="add">
                        <i class="el-icon-plus"></i>
                        <div class="btn-l">新增员工</div>
                    </div>
                </div>
            </div>
            <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
            </lb-table>
        </div>
        <!-- 查看员工浮层 -->
        <view-employment ref="viewEmployment"></view-employment>
        

    </div>
</template>
<script>
import eldate from '../../../components/eldate.vue'
import LbTable from '../../../components/lb-table/lb-table'
import viewEmployment from '@/components/viewEmployment'
export default {
    name: 'roster',
    components: {
        eldate,
        LbTable,
        viewEmployment
    },
    data() {
        return {
            showCalendar: true,
            statuss: [
                { dictId: 'A', dictName: '已转正' },
                { dictId: 'T', dictName: '试用' },
                { dictId: 'W', dictName: '待离职' }
            ],
            employeeTime: [],
            createTime: [],
            searchForm: {
                status: '',
                orgId: null,
                orgId1: [],
                positionId: null,
                reallyName: '',
                employeeStartTime: '',
                employeeEndTime: '',
                createStartTime: '',
                createEndTime: '',
                directSuperior: '',
                phoneNumber: '',
                pageNo: 1,
                pageSize: 10,
                allFlag: 0,
                ids: []
            },
            form: {
                name: ''
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            parArray: [],
            list: [],
            totalNum: 0,
            columns: [
                { type: 'selection', minWidth: '80' },
                { label: '登录手机号', prop: 'phoneNumber', width: '120' },
                { label: '员工姓名', prop: 'reallyName', width: '160' },
                { label: '员工工号', prop: 'serial', minWidth: '120' },
                { label: '钉钉登录手机号', prop: 'dingPhone', minWidth: '140' },
                { label: '工作手机号', prop: 'workPhone', width: '120' },
                { label: '性别', prop: 'sexLabel', width: '80' },
                { label: '入职日期', prop: 'employeeDate', width: '120' },
                { label: '职位', prop: 'positionName', minWidth: '120' },
                { label: '直接上级', prop: 'directSuperior', width: '150' },
                {
                    label: '在职状态', prop: 'statusLabel', width: '120',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusLabel == '已转正') {
                            vv = <p style="font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #00B498;;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else if (scope.row.statusLabel == '待离职') {
                            vv = <p style="font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background: #F5C401;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else {
                            vv = <p style="font-size:14px;display:flex;justify-content:center;"><div style="width: 8px;height: 8px;background:  #2D5DCF;border-radius: 50%;opacity: 1;margin-top:9px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>

                            // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
                        )
                    }
                },
                { label: '创建日期', prop: 'createdTime', minWidth: '120' },
                {
                    label: '操作', prop: 'orgName', minWidth: '120', fixed:"right",
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;justify-content:center">
                                {
                                    this.parArray.indexOf('deployee_detail') != -1 ? <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div> : ""
                                }
                                {
                                    this.parArray.indexOf('employee_update') != -1 ? <div style="cursor:pointer">
                                        <el-dropdown onCommand={($event) => { this.command($event, scope.row.id) }} >
                                            <span class="el-dropdown-link" style="color:#00B498">
                                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item class="custom-item" command="edit">编辑</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div> : ""
                                }

                            </div >
                        )
                    }
                },
            ],
           
            
            arr1: [
                {}, {

                }
            ],
            dictionaries: [],
            options: [],
            positionList: [],
            timeout: null,
            detail: {},
            roleDataList: [],

        }
    },
    created() {
        console.log(111)

        // console.log(sessionStorage.getItem('dictionaries'))
        let echartArr = []
        this.dictionaries = this.fmObjToArr(JSON.parse(sessionStorage.getItem('dictionaries')))
        this.department()
        this.getPositionList()
        this.fetchData()
        // this.getStaffs()
        // 权限设定判断 normsCode
        this.limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = this.limits.buttonTreeDto.find(
            (item) => item.menuCode === "roster"
        )
        params.buttonList.forEach((item) => {
            this.parArray.push(item.code)
        })
        // console.log('parArray>>',this.parArray)
    },
    activated() {
        console.log('activated')
        this.getList()
    },
    mounted() {

    },
    methods: {
        command(val, id) {
            if (val == 'edit') {
                this.$router.push({ path: '/staffManagement/editSatff?id='+id})
            }
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {
                    status: '',
                    orgId: null,
                    orgId1: [],
                    positionId: null,
                    reallyName: '',
                    employeeStartTime: '',
                    employeeEndTime: '',
                    createStartTime: '',
                    createEndTime: '',
                    directSuperior: '',
                    pageNo: 1,
                    pageSize: 10,
                    allFlag: 0,
                    ids: []
                }
                this.employeeTime = []
                this.createTime = []
                this.page.pageNo = 1; 
            } else {
                if (this.employeeTime && this.employeeTime.length > 0) {
                    this.searchForm.employeeStartTime = this.employeeTime[0]
                    this.searchForm.employeeEndTime = this.employeeTime[1]
                } else {
                    this.searchForm.employeeStartTime = ''
                    this.searchForm.employeeEndTime = ''
                }
                if (this.createTime && this.createTime.length > 0) {
                    this.searchForm.createStartTime = this.createTime[0]
                    this.searchForm.createEndTime = this.createTime[1]
                } else {
                    this.searchForm.createStartTime = ''
                    this.searchForm.createEndTime = ''
                }
            }
            this.searchForm.pageNo = this.page.pageNo
            this.searchForm.pageSize = this.page.pageSize
            if (type == 'search') {
                this.searchForm.pageNo = 1
                this.page.pageNo = 1
            }
            if (this.searchForm.orgId1) {
                this.searchForm.orgId = this.searchForm.orgId1[this.searchForm.orgId1.length - 1]
            }
            this.searchForm.ids = []
            this.axios.post('/oa/sys/employee/page', this.searchForm).then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.list = res.data.list || []
                    this.totalNum = res.data.totalNum
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        changeData(val, type) {
            console.log(val)
            if (type == 'employeeTime') {
                this.employeeTime = val
            } else {
                this.createTime = val
            }

        },
        getStaffs() {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.reallyName)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        this.staffs = res.data

                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        querySearch(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.reallyName)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })
                        this.staffs = res.data
                        var staffs = this.staffs;
                        var results = queryString ? staffs : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSelect(item) {
            this.searchForm.reallyName = item.name

        },
        querySearch1(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.searchForm.directSuperior)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })

                        var results = queryString ? res.data : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSelect1(item) {
            this.searchForm.directSuperior = item.name

        },
        handleSelectOrgId(e) {
            this.searchForm.orgId = e
        },
        // 查询职位下拉列表数据
        getPositionList() {
            const data = {}
            this.axios.post('/sys/v2/user/position/listSelect', data).then((res) => {
                if (res.code == 0) {
                    this.positionList = res.data
                }
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        // 部门选择列表
        department() {
            this.axios
                .post(
                    "/sys/v1/org/tree/select",
                    {
                        request: {
                            orgName: "",
                            orgType: "",
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.code == 0) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            console.log(arr)
            return arr
        },
        lookDetail(val) {
            this.$refs.viewEmployment.show(val.id)
        },
        add() {
            this.$router.push({ path: '/staffManagement/addSatff' })
        },
        deliverData() {
            if (this.searchForm.ids.length == 0) {
                this.$message.warning('请勾选导出的数据')
            } else {
                this.axios.post('/oa/sys/employee/export', this.searchForm).then(res => {
                    if (res.code == 0) {
                        this.downloadlink(res.data)
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })

                    }
                })
            }

        },
        downloadlink(url) {
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.src = url
            document.body.appendChild(iframe)
        },
        onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.searchForm.allFlag = 1
            // }
            if (val) {
                this.searchForm.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        getList() {
            this.axios.post('/oa/sys/employee/page', {}).then((res) => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.totalNum = res.data.totalNum
                }
                // console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        min-height: calc(100vh - 118px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        padding-bottom: 16px;
        border-bottom: 32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;
        .search-form {
            padding-top: 32px;
        }

        .line {
            width: 100%;
            height: 1px;
            background: #EDF2F2;
            border-radius: 0px 0px 0px 0px;
            margin-top: 16px;
            clear: both;
        }

        .data-title {
            width: 100%;
            height: 32px;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-line {
                width: 2px;
                height: 16px;
                background: #00B498;
                border-radius: 0px 0px 0px 0px;
                margin-top: 8px;
            }

            .title-name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
                margin-left: 4px;
                line-height: 32px;
            }

            .title-btn {
                display: flex;

                .title-btn-item {
                    width: 92px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E3E6E5;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 8px;
                    padding-right: 8px;
                    box-sizing: border-box;
                    cursor: pointer;

                    .btn-l {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #2F3030;

                    }
                }


            }
        }
    }


}


</style>
